import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { gameApi } from "../../services/game.api";
import {
  IUpdateGameScoreRequest,
  IUpdateGameScoreResponse,
  QUERY_KEYS,
} from "../../types/api";
import queryClient from "../../config/queryClient";

// Hook for adding game log
export const useGame = (
  options?: Omit<
    UseMutationOptions<
      IUpdateGameScoreResponse,
      Error,
      IUpdateGameScoreRequest
    >,
    "mutationFn" | "onSuccess"
  >
) => {
  return useMutation({
    mutationFn: (data: IUpdateGameScoreRequest) => gameApi.addGameLog(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GAME] });
    },
    ...options,
  });
};

export const gameHooks = {
  useGame,
};
